import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import MusicArtist from '../MusicArtist/MusicArtist';
import MusicArtistSkeletonturning from '../skeletons/artistskeletonturning';
import { firebaseFireStore } from '../../config/firebaseFirestore';
import {
  collection,
  orderBy,
  query,
  where,
  getDocs,
} from 'firebase/firestore/lite';

export default function ArtistsTab(props) {
  const userDataRedux = useSelector((state) => state.authReducer.userData);
  const [nftDataArr, setnftDataArr] = useState([]);
  const [loadingArtists, setloadingArtists] = useState(true);

  useEffect(() => {
    if (userDataRedux && userDataRedux.uid) {
      getSellerArtists();
    }
  }, [userDataRedux]);

  const getSellerArtists = async () => {
    setloadingArtists(true);

    let nftRef = query(
      collection(firebaseFireStore, 'musicartArtists'),
      where('creatorId', '==', userDataRedux.uid),
      orderBy('nftsCount'),
    );

    let nftData = await getDocs(nftRef);

    let dataArr = [];
    nftData.forEach((doc) => {
      dataArr.push({ ...doc.data(), id: doc.id });
    });

    setnftDataArr([...dataArr]);
    // console.log("data", dataArr);
    setloadingArtists(false);
  };

  return (
    <div className="seller__tab__pane" role="tabpanel">
      <div className="seller__tab__content">
        <div className="row row--grid">
          {loadingArtists ? (
            <div className="flex 	w-full my-6  " style={{ flexWrap: 'wrap' }}>
              <MusicArtistSkeletonturning />
              <MusicArtistSkeletonturning />
              <MusicArtistSkeletonturning />
              <MusicArtistSkeletonturning />
              <MusicArtistSkeletonturning />
              <MusicArtistSkeletonturning />
            </div>
          ) : (
            nftDataArr.map((ele, index) => {
              return (
                <div
                  style={{ display: 'block' }}
                  className="turning-screens-artist"
                  key={'artist-' + index}
                >
                  <MusicArtist ele={ele} state={ele.adminState} />
                </div>
              );
            })
          )}
          {!loadingArtists && nftDataArr.length === 0 && (
            <div className="text-center w-full text-blueGray-500">
              <p className="text-center mt-10">0 Artists found</p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
